import { render, staticRenderFns } from "./ClientSideBar.vue?vue&type=template&id=06c5256f&lang=pug&"
import script from "./ClientSideBar.vue?vue&type=script&lang=js&"
export * from "./ClientSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ClientSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports